export default __webpack_public_path__ + "static/header-d658e4bc205bdd37fde4ed218411429a.png";